import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { PanelModule } from 'primeng/primeng';
import { AutoCompleteModule, DataGridModule, CalendarModule, DropdownModule, SelectButtonModule, DialogModule } from 'primeng/primeng';
import { BusyModule } from 'angular2-busy';
import { ToastyModule } from 'ng2-toasty';

import { CookieService } from 'angular2-cookie/services/cookies.service';

import { AppRoutingModule } from './app-routing.module';

import { AuthGuard } from './shared/services/auth-guard.service';
import { AuthService } from './shared/services/auth.service';
import { HelperService } from './shared/services/helper.service';
import { SettingService } from './shared/services/setting.service';
//import { ProcessService } from './shared/services/process.service';
import { StoreService } from './shared/services/store.service';
import { DockService } from './shared/services/dock.service';
import { MemberService } from './shared/services/member.service';
import { HttpService } from './shared/services/http.service';
import { MyErrorHandler } from './shared/services/error.handler';

import { MimePipe } from './shared/pipes/mime.pipe';

import { ElementFocusDirective } from './shared/directives/element-focus.directive';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
//import { ResultsComponent } from './results/results.component';
//import { ResultComponent } from './result/result.component';
import { PageNotFoundComponent } from './pagenotfound/pagenotfound.component';

import { ListItemComponent } from './list-item/list-item.component';
import { FeedService } from './shared/services/feed.service';

//import * as $ from 'jquery';
import { SlickModule } from 'ngx-slick';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    PageNotFoundComponent,
    MimePipe,
      ElementFocusDirective,
      ListItemComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    ToastyModule.forRoot(),
    HttpModule,
    AppRoutingModule,
    PanelModule,
    DialogModule,
    AutoCompleteModule,
    DataGridModule,
    CalendarModule,
    DropdownModule,
    SelectButtonModule,
      BusyModule,
    SlickModule.forRoot()
  ],
  providers: [
    { provide: ErrorHandler, useClass: MyErrorHandler },
    HttpService,
    AuthGuard,
    AuthService,
    HelperService,
    SettingService,
    DockService,
    StoreService,
      CookieService,
      MemberService,
      FeedService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts